import type { SkillGroup } from './types';

/**
 * Verbatim from v6.1. No proficiency levels: neither source resume assigns
 * them, and inventing "React — 4/5" would fabricate a claim on a document
 * employers read as factual (PLAN.md §4.5).
 *
 * Obsolete entries present only in the 2022-era v4 resume — Struts, JSP, SOAP,
 * jQuery, log4j, Ant, WAS7/WAS9 — are deliberately excluded; they would date
 * the profile against the modern backend positioning v6.1 builds.
 */
export const skills: SkillGroup[] = [
  {
    category: 'Languages',
    skills: ['Java (8, 11, 17)', 'Python', 'SQL', 'JavaScript', 'TypeScript'],
    featured: true,
  },
  {
    category: 'Backend Frameworks',
    skills: [
      'Spring Boot',
      'Spring MVC',
      'Spring Web',
      'Spring Data JPA',
      'Spring Data MongoDB',
      'Hibernate',
      'JDBC',
      'Servlets',
      'FastAPI',
    ],
    featured: true,
  },
  {
    // Scoped as personal-project work. Listing seven feature names as bare
    // skills would match AI job descriptions and get him screened on production
    // LLM experience he does not have.
    category: 'AI / ML (personal project)',
    skills: ['LLM Integration (Ollama)', 'Distributed Inference', 'Load-Based Worker Scheduling'],
    featured: true,
  },
  {
    category: 'APIs & Architecture',
    skills: [
      'RESTful APIs',
      'Swagger/OpenAPI',
      'Microservices',
      'Event-Driven Processing',
      'Service-Layer Design',
    ],
  },
  {
    category: 'Cloud',
    skills: [
      'AWS EC2',
      'AWS S3',
      'AWS Lambda',
      'AWS Kinesis Stream',
      'AWS CloudWatch',
      'Azure Web Apps',
      'Azure Functions',
      'Azure Storage Accounts',
      'Azure Data Factory',
    ],
    featured: true,
  },
  {
    category: 'Databases',
    skills: ['MongoDB', 'MySQL', 'DB2'],
  },
  {
    category: 'DevOps & Monitoring',
    skills: ['GitLab CI/CD', 'Jenkins', 'Docker', 'Docker Compose', 'Maven', 'Git', 'Kibana'],
  },
  {
    category: 'Testing & Code Quality',
    skills: [
      'JUnit',
      'Mockito',
      'Selenium',
      'pytest',
      'Vitest',
      'JaCoCo',
      'SonarQube',
      'Secure Coding',
    ],
  },
  {
    // Frontend row removed: targeting Java backend roles only. React and Vite
    // remain in the DevForge project stack, where they read as project context
    // rather than a capability being offered. TypeScript is still listed under
    // Languages. Angular stays in the TCS bullet as history.
    category: 'Methodologies & Tools',
    skills: ['Agile', 'Scrum', 'Code Reviews', 'Jira', 'Postman', 'Eclipse/STS', 'VS Code'],
  },
];
